module.exports = __webpack_public_path__ + "images/emoji/womans_clothes.4c8edbd357a3a9f27566.png";